import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../../login/authentication.service'

import { Router, ActivatedRoute } from '@angular/router';
import { GetparticipantService } from '../getparticipant.service';
import { UnixtimeService } from '../../../../shared/unixtime.service';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { MenutitleService } from '../../../../shared/menutitle.service';
import { BeepService } from '../../../../shared/beep.service';
import { VibrateService } from '../../../../shared/vibrate.service'

import { MenucontentService } from '../../../../shared/menucontent.service';

import { UploadcounterService } from '../../../../shared/uploadcounter.service';

import {
  UntypedFormControl,
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormGroup,
  NgForm,
  Validators,
} from '@angular/forms';

import { ErrorStateMatcher } from '@angular/material/core';

import { ShowmenuService } from '../../../../shared/showmenu.service';

import { first } from 'rxjs/operators';

import { ParticipantformService } from '../participantform.service';
import { AnonymousSubject } from 'rxjs/internal/Subject';
//import { SelectorMatcher } from '@angular/compiler';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: UntypedFormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: 'app-participantedit',
  templateUrl: './participantedit.component.html',
  styleUrls: ['./participantedit.component.css'],
})
export class ParticipanteditComponent implements OnInit {
  loading = true;
  participantdata: any;
  participantForm: UntypedFormGroup;
  qrcode: any;
  data: any;
  matcher = new MyErrorStateMatcher();
  items = JSON.parse(localStorage.getItem('currentUser'));
  participant_json: any;

  selectedGame: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private AuthenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private GetparticipantService: GetparticipantService,
    private ShowmenuService: ShowmenuService,
    public ParticipantformService: ParticipantformService,
    private UnixtimeService: UnixtimeService,
    private dbService: NgxIndexedDBService,
    private menutitle: MenutitleService,
    private BeepService: BeepService,
    private VibrateService: VibrateService,
    private MenucontentService: MenucontentService,
    private UploadcounterService: UploadcounterService
  ) {}

  onSubmit() {
    if (this.participantForm.valid) {
      console.log(this.participantForm.value);
    } else {
      return;
    }

    this.BeepService.beep();
    this.VibrateService.vibrate();

    //alert(this.participantForm.controls['participant'].value.participant_column1)

    this.participant_json = {
      type: 'participant',
      client_id: localStorage.getItem('global_client_id'),
      device_id: localStorage.getItem('global_device_id'),
      client_pin: localStorage.getItem('global_client_pin'),
      event_id: this.participantForm.controls.participant_event_id.value,
      race_number: this.qrcode,
      column1: this.participantForm.controls[
        'participant'
      ].value.participant_column1.toString(),
      column2: this.participantForm.controls[
        'participant'
      ].value.participant_column2.toString(),
      column3: this.participantForm.controls[
        'participant'
      ].value.participant_column3.toString(),
      column4: this.participantForm.controls[
        'participant'
      ].value.participant_column4.toString(),
      column5: this.participantForm.controls[
        'participant'
      ].value.participant_column5.toString(),
      column6: this.participantForm.controls[
        'participant'
      ].value.participant_column6.toString(),
      column7: this.participantForm.controls[
        'participant'
      ].value.participant_column7.toString(),
      column8: this.participantForm.controls[
        'participant'
      ].value.participant_column8.toString(),
      column9: this.participantForm.controls[
        'participant'
      ].value.participant_column9.toString(),
      column10: this.participantForm.controls[
        'participant'
      ].value.participant_column10.toString(),
      last_update: this.UnixtimeService.unixtime(),
    };

    this.dbService
      .add('timingmobi', {
        json: this.participant_json,
      })
      .subscribe((key) => {
        //console.log('key: ', key);

        this.dbService.count('timingmobi').subscribe((peopleCount) => {
          this.UploadcounterService.changeUploadTotal(peopleCount);
        });

        if (localStorage.getItem('global_input_method') == 'scan') {
          this.router.navigateByUrl('/participantscan');
        } else {
          this.router.navigateByUrl('/participantkeyboard');
        }
      });
  }

  goback() {
    var current_route = decodeURI(localStorage.getItem('global_current_route'));
    this.router.navigate([current_route]);

    //this.router.navigate(['/participantscan']);
  }

  ngOnInit(): void {
    this.AuthenticationService.check_logged_in()
    
    // https://stackoverflow.com/questions/43270564/dividing-a-form-into-multiple-components-with-validation
    this.participantForm = this.formBuilder.group({
      participant_event_id: ['', [Validators.required]],
      participant: this.formBuilder.group({
        // create nested formgroup to pass to child
        participant_column1: [''],
        participant_column2: [''],
        participant_column3: [''],
        participant_column4: [''],
        participant_column5: [''],
        participant_column6: [''],
        participant_column7: [''],
        participant_column8: [''],
        participant_column9: [''],
        participant_column10: [''],
      }),
    });

    this.ShowmenuService.changeShowmenu(true);
    this.MenucontentService.changeMenuMassStart();
    this.MenucontentService.changeMenuIndividualStart();
    this.MenucontentService.changeCheckpoints();

    this.menutitle.changeMenutitle('Manage Participants');
    this.menutitle.showMenupink(false);

    this.route.paramMap.subscribe((params) => {
      this.qrcode = params.get('qrcode');
    });

    this.GetparticipantService.getparticipant(this.qrcode)
      .pipe(first())
      .subscribe({
        next: (response) => {
          this.data = JSON.stringify(response);

          this.loading = false;
          this.ParticipantformService.change_event_fields(
            response.participant_event_id
          );

          if (response.participant_event_id > 0) {
            this.participantForm.setValue({
              participant_event_id: response.participant_event_id.toString(),
              participant: {
                participant_column1: response.participant_column1,
                participant_column2: response.participant_column2,
                participant_column3: response.participant_column3,
                participant_column4: response.participant_column4,
                participant_column5: response.participant_column5,
                participant_column6: response.participant_column6,
                participant_column7: response.participant_column7,
                participant_column8: response.participant_column8,
                participant_column9: response.participant_column9,
                participant_column10: response.participant_column10,
              },
            });
          } else {
            this.participantForm.setValue({
              participant_event_id: null,
              participant: {
                participant_column1: response.participant_column1,
                participant_column2: response.participant_column2,
                participant_column3: response.participant_column3,
                participant_column4: response.participant_column4,
                participant_column5: response.participant_column5,
                participant_column6: response.participant_column6,
                participant_column7: response.participant_column7,
                participant_column8: response.participant_column8,
                participant_column9: response.participant_column9,
                participant_column10: response.participant_column10,
              },
            });
          }
        },
        error: (error) => {
          //this.error = error;
          this.loading = false;
        },
      });
  }
}

// https://offering.solutions/blog/articles/2018/11/21/online-and-offline-sync-with-angular-and-indexeddb/
// https://medium.com/better-programming/angular-6-url-parameters-860db789db85

// Dropdown Validation
// https://www.djamware.com/post/5e379e4fd598ef0e8bbcc67e/angular-material-form-controls-select-mat-select-example
// https://offering.solutions/blog/articles/2020/05/03/cross-field-validation-using-angular-reactive-forms/
